/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classname from 'classnames';
import * as React from 'react';

export interface IProgressProps {
    id?: string;
    className?: string;
    max: number;
    min?: number;
    value: number;
    ariaLabel?: string;
}

export const Progress: React.FC<IProgressProps> = (props: IProgressProps) => {
    const { id, className, max, min, value, ariaLabel } = props;
    const percent = Math.max(0, Math.min((value * 100) / max, 100));
    const style = { width: `${percent}%` };

    return (
        <div className={classname('msc-progress', className)} aria-busy={percent < 100}>
            <div
                className="msc-progress__bar"
                style={style}
                id={id}
                role="progressbar"
                aria-valuemax={max}
                aria-valuenow={value}
                aria-valuemin={min}
                aria-label={ariaLabel}
                aria-busy={percent < 100}
            />
        </div>
    );
};

// Set default props
Progress.defaultProps = {
    'aria-valuemax': 100,
    'aria-valuenow': 0
} as Partial<IProgressProps>;

export default Progress;
